export enum TipoPopUpEnum {
	Ninguno = 1,
	Mensaje,
	Confirmacion,
	Imagen,
	IFrame
}